import { render, staticRenderFns } from "./LicencaCadastroModal.vue?vue&type=template&id=6cb11f7a&scoped=true"
import script from "./LicencaCadastroModal.vue?vue&type=script&lang=js"
export * from "./LicencaCadastroModal.vue?vue&type=script&lang=js"
import style0 from "./LicencaCadastroModal.vue?vue&type=style&index=0&id=6cb11f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb11f7a",
  null
  
)

export default component.exports